<template>
    <div>
        
        <v-row>
            <v-col cols="11">
                There are 6 types of feats:
            </v-col>
            <v-col cols="1">
                <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="showGameDesc" label="Game Desc"></v-checkbox>
            </v-col>
        </v-row>
        <ul>
            <li><a @click="scrollTo('martial')">Martial</a></li>
            <li><a @click="scrollTo('magic')">Magic</a></li>
            <li><a @click="scrollTo('utility')">Universal</a></li>
            <li><a @click="scrollTo('teamwork')">Teamwork</a></li>
            <li><a @click="scrollTo('style')">Style</a></li>
            <li><a @click="scrollTo('metamagic')">Metamagic</a></li>
        </ul>
        <br/><br/>
        <div v-for="type in types" :key="type">
            <h2 v-if="type != 'metamagic'" :id="type" style="color:cornflowerblue">{{type[0].toUpperCase() + type.substr(1)}} Feats:</h2>                    
            <table>
                <tr> 
                    <th>Name</th>
                    <th>Feat Prerequisite</th>
                    <th>Perk Prerequisite</th>
                    <th>Description</th>
                </tr>
                <tr v-for="feat in sortedFeats(type)" :key="feat.name">                     
                    <td style="text-align:center" v-if="!feat.prereq"><v-divider style="ml-1"  vertical :thickness="5"></v-divider>{{feat.name}}</td>
                    <td style="text-align:center" v-else>
                        <v-row>
                            <v-col cols="3" no-gutters style="align-self:center;" class="pa-0">
                                ->
                            </v-col>
                            <v-col cols="9" no-gutters style="align-self:center;white-space:normal" class="pl-0">
                                {{feat.name}}
                            </v-col>
                        </v-row>
                    </td>
                    <td style="padding-left:4px; padding-right:4px">{{feat.prereq}}</td>
                    <td style="padding-left:4px; padding-right:4px">
                        <span v-for="preReq in feat.perkPrereq" :key="preReq"
                        >{{preReq}},
                        </span>
                    </td>
                    <td style="padding-left:4px; padding-right:4px">{{ showGameDesc && feat.gameDesc ? feat.gameDesc : feat.longDesc.length > 0 ? feat.longDesc : feat.shortDesc}}</td>                    
                </tr>
            </table>           
            <br/>
        </div>
        <h2 id="metamagic" style="color:cornflowerblue">Metamagic Feats:</h2>                    
        <table>
            <tr> 
                <th>Name</th>
                <th>Cost</th> 
                <th>Description</th>
            </tr>
            <tr v-for="feat in sortedFeats('meta')" :key="feat.name"> 
                <td style="text-align:center">{{feat.name}}</td>
                <td style="padding-left:4px; padding-right:4px; text-align:center">{{feat.cost}}</td>
                <td style="padding-left:4px; padding-right:4px">{{showGameDesc && feat.gameDesc ? feat.gameDesc : feat.longDesc}}</td>
                </tr>
        </table>      
        <v-icon style="position:fixed; right:16px; bottom:16px; color:cornflowerblue" outlined large @click="scrollTo('top')">mdi-arrow-up-circle</v-icon>
    </div>
</template>
<script>
import {feats, metamagic} from "../../../play/data"

export default {
  components: {
  },
  props:{
  },
  mounted(){
  },
  data(){
      return{
          types:['martial', 'magic', 'utility', 'teamwork',"style"],
          showGameDesc: false,
      }
  },
  methods:{
      sortedFeats(type){
        let allFeats = []
        let sortedFeats = []
        let prereqFeats = []
        let sorted = []
        if(this.types.includes(type)){
            allFeats = [...feats]            
            allFeats.forEach(feat=>{
                if(feat.type == type && !feat.secret){
                    if(!feat.prereq){
                        sortedFeats.push(feat)
                    }else{
                        //try{
                            if(allFeats.filter(prereq=> prereq.name == feat.prereq)[0].type == type){
                            prereqFeats.push(feat)
                            }else{
                                sortedFeats.push(feat)
                            }
                        // }catch{
                        //     console.log("broken feat: ", feat)
                        // }                     
                        
                    }
                }
            })
            sorted = sortedFeats.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
            prereqFeats.forEach(prereqFeat =>{
                let index = sorted.findIndex(feat =>{
                    return feat.name == prereqFeat.prereq
                })
                sorted.splice(index+1, 0, prereqFeat)
            })
            sortedFeats = allFeats.filter(feat=>feat.type == type && !feat.prereq)
            console.log()
        }else{
            sortedFeats = [...metamagic]
            sorted = sortedFeats.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
        }
        
        return sorted
      },
      scrollTo(id){
        if(id == 'top'){
            window.scrollTo({top: 0, behavior: 'instant'});
        }else{
            let section = document.getElementById(id)
            section.scrollIntoView({behavior: "smooth"})
        }
      },
  }

}
</script>
<style scoped>
table, th, td {
  border:1px solid black;
}
</style>